import { render, staticRenderFns } from "./CguDoc.vue?vue&type=template&id=206661ac&scoped=true"
import script from "./CguDoc.vue?vue&type=script&lang=js"
export * from "./CguDoc.vue?vue&type=script&lang=js"
import style0 from "./CguDoc.vue?vue&type=style&index=0&id=206661ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206661ac",
  null
  
)

export default component.exports